// Mock data for Destiny Digits - Numerology by Mrs. Pujah Chopraa

export const brand = {
  name: 'Destiny Digits',
  tagline: 'Own your destiny before it owns you',
  practitioner: 'Mrs. Pujah Chopraa',
  honorific: 'Master Numerologist & Spiritual Guide',
};

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Calculators', href: '#calculators' },
  { label: 'Book a Reading', href: '#reading' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

export const services = [
  {
    id: 1,
    title: 'Numerology Consultation',
    icon: 'Sparkles',
    items: [
      'Issue-Based Consultation',
      'Current / Ongoing Issues',
      'Future Roadmapping',
      'Numerology Chart Detailed Analysis',
    ],
  },
  {
    id: 2,
    title: 'Career & Job Counselling',
    icon: 'Briefcase',
    items: [
      'Career Roadmapping',
      'Milestones & Pitfalls',
      'Guidance to Promotion & Recognition',
      'Spiritual Strengths',
    ],
  },
  {
    id: 3,
    title: 'Baby Name & Child Analysis',
    icon: 'Baby',
    items: [
      'Child Name Check, Correction & Counselling',
      'Cesarian Child Date Selection',
      'Child Safety & Bad Company',
      'Spiritual Strengths',
    ],
  },
  {
    id: 4,
    title: 'Matrimonial Consultation',
    icon: 'Heart',
    items: [
      'Marriage Compatibility',
      'Divorce & Litigation Roadmapping',
      'ReMarriage Consultation',
      'Other Relationship Consultation',
    ],
  },
  {
    id: 5,
    title: 'Business Consultation',
    icon: 'TrendingUp',
    items: [
      'Partnership Compatibility',
      'Name, Brand, Logo, Address',
      'Succession Planning',
      'Time to Expand, Divest or Diversify',
    ],
  },
];

export const stats = [
  { value: '21,000+', label: 'Clients Guided' },
  { value: '53+', label: 'Countries' },
  { value: '4', label: 'Books Published' },
  { value: '4,00,000+', label: 'Followers' },
];

export const events = {
  india: [
    { title: 'Batch 39 – Live Workshop', date: 'Wed, April 1, 2026', location: 'Mumbai, India' },
  ],
  online: [
    { title: 'How Numerology Helps in Your Career (Webinar)', date: '13th December', location: 'Online' },
    { title: 'Batch 38 – Numerology Course', date: '17th December', location: 'Zoom' },
  ],
  international: [
    { title: 'Dubai – Soul Blueprint Masterclass', date: '22nd January', location: 'Dubai, UAE' },
    { title: 'London – Destiny Decoded', date: '14th February', location: 'London, UK' },
  ],
};

export const testimonials = [
  {
    id: 1,
    name: 'Anaya Mehra',
    role: 'Entrepreneur, Mumbai',
    quote:
      'Mrs. Pujah\u2019s reading was uncannily precise. Within months of my name correction, two long\u2011stalled deals closed. It feels less like consultation and more like coming home to myself.',
  },
  {
    id: 2,
    name: 'Rohan Kapoor',
    role: 'Tech Executive, Bengaluru',
    quote:
      'I came in skeptical. I left with a roadmap. The career milestones she predicted have unfolded almost to the month. Worth every minute.',
  },
  {
    id: 3,
    name: 'Sara Williams',
    role: 'Author, London',
    quote:
      'A truly classy, soulful experience. Destiny Digits doesn\u2019t sell predictions \u2014 it gifts perspective. My writing, my relationships, my finances all shifted.',
  },
  {
    id: 4,
    name: 'Devansh Iyer',
    role: 'Founder, Singapore',
    quote:
      'The business naming session reshaped our brand identity. Sales doubled in the next two quarters. Mrs. Chopraa is a quiet force.',
  },
  {
    id: 5,
    name: 'Ishita Rao',
    role: 'Doctor, Delhi',
    quote:
      'Her compatibility reading saved my marriage from quiet drift. Honest, gentle, deeply intuitive. Forever grateful.',
  },
];

export const videoGallery = [
  { id: 'dQw4w9WgXcQ', title: 'What Your Birth Number Reveals', thumb: 'https://images.pexels.com/photos/6931870/pexels-photo-6931870.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: 'oHg5SJYRHA0', title: 'The Power of Name Numerology', thumb: 'https://images.pexels.com/photos/6932066/pexels-photo-6932066.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: '9bZkp7q19f0', title: 'Compatibility \u2014 Decoded', thumb: 'https://images.pexels.com/photos/10916183/pexels-photo-10916183.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: 'kJQP7kiw5Fk', title: 'Karmic Lessons & Life Path', thumb: 'https://images.pexels.com/photos/26839616/pexels-photo-26839616.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
];

export const featuredBook = {
  title: 'The Life Transformed',
  subtitle: 'Reveals Your Soul\u2019s Blueprint, Hidden Patterns & Destiny Cycles',
  cover: 'https://images.unsplash.com/photo-1640013097686-6879c7c4a59b?crop=entropy&cs=srgb&fm=jpg&q=85',
  bullets: [
    'Decode your soul\u2019s blueprint with ancient Chaldean numerology',
    'Uncover hidden patterns shaping your relationships & wealth',
    'Navigate destiny cycles with precision rituals & remedies',
    'A modern guide steeped in 40+ years of practice',
  ],
};

export const heroPortrait =
  'https://images.unsplash.com/photo-1622207691293-5cd80466dab3?crop=entropy&cs=srgb&fm=jpg&q=85';
export const aboutPortrait =
  'https://images.unsplash.com/photo-1716504628084-97224213ca6d?crop=entropy&cs=srgb&fm=jpg&q=85';
export const sacredGeoBg =
  'https://images.pexels.com/photos/34871975/pexels-photo-34871975.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
